"use strict";

/// <reference types="jquery"/>
$.fn.initTemplate = function () {
    var $container = $(this),
        $table = $container.find("table.table-templates");
    $table.on("preInit.dt", function (e, settings) {
        $container.addCheckBoxFilter("Usage :", "usage", settings);
    });
    $container.setDatatableAdmin();
    return $table;
};
$(function () {
    $("div.template-container").initTemplate();
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Templates/index.ts
// module id = 604
// module chunks = 0